/**
 * ツールバー設定値
 *
 * 値の変更がロジックに触れずに済むよう、純粋なデータのみを置く
 */

/** value=適用する値, label=UI 表示名。font / style / fontsize の各セレクタで使う */
export interface RichTextSelectItem {
  value: string;
  label: string;
}

/** align ポップアップの 1 項目。cmd は directive 側で解釈する識別子 */
export interface RichTextAlignItem {
  icon: string;
  cmd: 'left' | 'center' | 'right' | 'justify' | 'indent' | 'outdent';
  label: string;
}

/** フォント候補。value は font-family にそのまま入る */
export const FONT_LIST: readonly RichTextSelectItem[] = [
  { value: 'Arial,sans-serif', label: 'Arial' },
  { value: '"Arial Black",sans-serif', label: 'Arial Black' },
  { value: '"Comic Sans MS",cursive', label: 'Comic Sans MS' },
  { value: '"Courier New",monospace', label: 'Courier New' },
  { value: '"Helvetica Neue",sans-serif', label: 'Helvetica Neue' },
  { value: 'Helvetica,sans-serif', label: 'Helvetica' },
  { value: 'Impact,sans-serif', label: 'Impact' },
  { value: '"Lucida Grande",sans-serif', label: 'Lucida Grande' },
  { value: 'Tahoma,sans-serif', label: 'Tahoma' },
  { value: '"Times New Roman",serif', label: 'Times New Roman' },
  { value: 'Verdana,sans-serif', label: 'Verdana' },
];

/** 「文字のスタイル」候補。value はブロックタグ名 */
export const STYLE_LIST: readonly RichTextSelectItem[] = [
  { value: 'p', label: '本文' },
  { value: 'h1', label: '見出し1' },
  { value: 'h2', label: '見出し2' },
  { value: 'h3', label: '見出し3' },
  { value: 'h4', label: '見出し4' },
  { value: 'h5', label: '見出し5' },
  { value: 'h6', label: '見出し6' },
  { value: 'blockquote', label: '引用' },
  { value: 'pre', label: 'ブロック' },
];

export const FONTSIZE_LIST: readonly string[] = ['8', '9', '10', '11', '12', '13', '14', '18', '24', '36'];

export const LINEHEIGHT_LIST: readonly string[] = ['1.0', '1.2', '1.4', '1.5', '1.6', '1.8', '2.0', '3.0'];

/** カラーパレット。グレースケール + 純色 + 濃淡の 8 列 × 8 行 */
export const COLOR_PALETTE: readonly string[] = [
  '#000000',
  '#424242',
  '#636363',
  '#9c9c94',
  '#cec6ce',
  '#efefef',
  '#f7f7f7',
  '#ffffff',
  '#ff0000',
  '#ff9c00',
  '#ffff00',
  '#00ff00',
  '#00ffff',
  '#0000ff',
  '#9c00ff',
  '#ff00ff',
  '#f7c6ce',
  '#ffe7ce',
  '#ffefc6',
  '#d6efd6',
  '#cedee7',
  '#cee7f7',
  '#d6d6e7',
  '#e7d6de',
  '#e79c9c',
  '#ffc69c',
  '#ffe79c',
  '#b5d6a5',
  '#a5c6ce',
  '#9cc6ef',
  '#b5a5d6',
  '#d6a5bd',
  '#e76363',
  '#f7ad6b',
  '#ffd663',
  '#94bd7b',
  '#73a5ad',
  '#6badde',
  '#8c7bc6',
  '#c67ba5',
  '#ce0000',
  '#e79439',
  '#efc631',
  '#6ba54a',
  '#4a7b8c',
  '#3984c6',
  '#634aa5',
  '#a54a7b',
  '#9c0000',
  '#b56308',
  '#bd9400',
  '#397b21',
  '#104a5a',
  '#085294',
  '#311873',
  '#731842',
  '#630000',
  '#7b3900',
  '#846300',
  '#295218',
  '#083139',
  '#003163',
  '#21104a',
  '#4a1031',
];

export const ALIGN_ITEMS: readonly RichTextAlignItem[] = [
  { icon: 'align', cmd: 'left', label: '左揃え' },
  { icon: 'center', cmd: 'center', label: '中央揃え' },
  { icon: 'right', cmd: 'right', label: '右揃え' },
  { icon: 'justify', cmd: 'justify', label: '両端揃え' },
  { icon: 'indent_increase', cmd: 'indent', label: 'インデントを増やす' },
  { icon: 'indent_decrease', cmd: 'outdent', label: 'インデントを減らす' },
];

/** インデント 1 段あたりの margin-left。属性値(段数)と CSS の相互変換に使う */
export const INDENT_STEP_PX = 40;

/** インデントの最大段数 */
export const INDENT_MAX = 8;

/** 既定のツールバー構成。config.buttons で上書き可 */
export const DEFAULT_BUTTONS =
  'bold,italic,underline,eraser,|,font,|,paragraph,|,fontsize,|,brush,|,ul,ol,align,|,lineHeight,|,table,|,link';
